import { useCallback, useMemo, useState } from 'react';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import { usePageMeta } from '@/hooks/usePageMeta';
import { faqs, trendingList } from '@/mocks/trending';
import Hero from './components/Hero';
import TrendingBoard from './components/TrendingBoard';
import TopicExplorer from './components/TopicExplorer';
import FeaturedDigest from './components/FeaturedDigest';
import CommentWall from './components/CommentWall';
import FaqSection from './components/FaqSection';

export default function Home() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('all');

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '黑料今日',
        alternateName: '今日娱乐热点聚合',
        description: '把今日热点事件与热门话题聚合在一起，热搜盘点与热议焦点同一页浏览。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://heiliao-today.example/?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '黑料今日',
        description: '面向简体中文用户的娱乐热点聚合与热搜盘点内容站。',
        email: 'contact@heiliao-today.example',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '今日热搜盘点',
        itemListElement: trendingList.slice(0, 10).map((item) => ({
          '@type': 'ListItem',
          position: item.rank,
          name: item.title,
        })),
      },
    ],
    []
  );

  usePageMeta({
    title: '黑料今日 - 今日热点事件与热门话题聚合 | 热搜盘点一页看完',
    description:
      '黑料今日聚合今日热点事件与热门话题，影视片场、音乐现场、综艺录制、品牌合作、粉丝圈层一次扫完。热搜盘点与热议焦点都在同一页，省去多平台来回切换的时间。',
    keywords: '黑料今日,黑料今日热点事件,黑料今日热门话题,黑料今日热搜盘点,黑料今日焦点',
    path: '/',
    jsonLd,
  });

  const handleHeroSearch = useCallback((value: string) => {
    setQuery(value);
    const target = document.getElementById('topics');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteNavbar />
      <main className="flex-1">
        <Hero onSearch={handleHeroSearch} />
        <TrendingBoard />
        <TopicExplorer query={query} setQuery={setQuery} category={category} setCategory={setCategory} />
        <FeaturedDigest />
        <CommentWall />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}